import React, {useState, useEffect, Fragment} from 'react';

import {createTheme, ThemeProvider} from '@material-ui/core/styles';
//redux
import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';
import {Store} from '../../redux/reducers';
import {
  makeSelectError,
  makeSelectLoading,
  makeSelectPartnerConfigs,
} from './notificationSaga/selectors';
import {
  getPartnerConfigsAction,
  updatePartnerConfigs,
} from './notificationSaga/actions';

// types and interfaces
// import {addProvider, Payload, PayloadCreate, Props, State} from './interfaces';
//style
import {
  Paper,
  Grid,
  Button,
  Divider,
  Switch,
  Typography,
} from '@material-ui/core';
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        '@media (max-width: 768px)': {
          margin: theme.spacing(0),
        },
      },
    },
    paper: {
      marginTop: '16px',
      marginBottom: '16px',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: '1px solid #ddd',
      borderRadius: '4px',
    },
    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 500,
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    divider: {
      width: '98%',
      margin: '10px auto',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '10px',
    },
    headerBox: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '28px',
    },
    contentlabelTitle: {
      position: 'relative',
      color: theme.palette.gray.light,
      marginLeft: '40px',
      fontSize: '14px',
      fontWeight: 500,
      '&:before': {
        content: '"-"',
        position: 'absolute',
        left: '-20px',
      },
    },
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    changStatusIcon: {
      marginRight: '10px',
      position: 'absolute',
    },
    changStatusBox: {
      display: 'flex',
      textAlign: 'left',

      fontWeight: 400,
      fontSize: '14px',
    },
    renderValue: {
      paddingLeft: '32px',
    },
    radioGroup: {
      margin: '-8px 0',
    },
    radioGroupItem: {
      borderBottom: '1px solid #D8D8D8',
      marginRight: '-8px',
      padding: '8px 16px',
      '&:last-child': {
        borderBottom: '0px',
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'justify',
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    card: {
      minWidth: '600px',
      display: 'flex',
      background: '#fff',
      padding: '8px 4px',
      borderRadius: '4px',
      marginTop: '25px',
    },
    cardItem: {
      margin: '0 4px',
      flex: 1,
    },
  })
);

const Notification = (props: any) => {
  //assets
  const classes = useStyles();
  //states
  const [notificationsType, setNotificationsType] = useState('Cargo');
  const [notificationSwitchs, setNotificationSwitchs] = useState([]);
  //functions
  const handleFilterNotifications = (type: string) => {
    setNotificationsType(type);
  };
  const switchHandler = (element: number, name: string) => {
    const container = [...notificationSwitchs];
    container[element].name = name;
    container[element][name] = !container[element][name];
    setNotificationSwitchs(container);
  };
  const getPartnerConfig = () => {
    const partnerId = localStorage.getItem('partnerId');
    const payload = {};
    props.partnerConfigsDispatch(payload);
  };
  const handleSubmitNotifications = () => {
    const partnerId = localStorage.getItem('partnerId');
    const payload = {
      body: {
        parcelAssigned: notificationSwitchs[0].parcelAssigned,
        parcelUnloaded: notificationSwitchs[1].parcelUnloaded,
        parcelLocated: notificationSwitchs[2].parcelLocated,
        parcelConflicted: notificationSwitchs[3].parcelConflicted,
        orderRegisterInPost: notificationSwitchs[4].orderRegisterInPost,
      },
      id: partnerId,
    };
    props.updatePartnerConfigsDispatch(payload);
  };
  //effects
  useEffect(() => {
    getPartnerConfig();
  }, [notificationsType]);
  useEffect(() => {
    const container = [
      {name: '', parcelAssigned: props.partnerConfigs.parcelAssigned},
      {name: '', parcelUnloaded: props.partnerConfigs.parcelUnloaded},
      {name: '', parcelLocated: props.partnerConfigs.parcelLocated},
      {name: '', parcelConflicted: props.partnerConfigs.parcelConflicted},
      {name: '', orderRegisterInPost: props.partnerConfigs.orderRegisterInPost},
    ];
    setNotificationSwitchs(container);
  }, [props.partnerConfigs]);
  return (
    <Paper>
      <Grid container>
        <Grid item>
          <div className={classes.card}>
            <div className={classes.cardItem}>
              <Button
                fullWidth
                color="secondary"
                size="medium"
                variant={
                  notificationsType === 'ORDERS' ? 'contained' : undefined
                }
                onClick={() => {
                  handleFilterNotifications('ORDERS');
                }}
              >
                سفارش
              </Button>
            </div>
            <div className={classes.cardItem}>
              <Button
                fullWidth
                color="secondary"
                size="medium"
                variant={
                  notificationsType === 'Cargo' ? 'contained' : undefined
                }
                onClick={() => {
                  handleFilterNotifications('Cargo');
                }}
              >
                محموله
              </Button>
            </div>
          </div>
        </Grid>
        <Grid item></Grid>
      </Grid>
      <Divider className={classes.divider} />
      {notificationSwitchs[0]?.parcelAssigned !== undefined && (
        <Fragment>
          {notificationsType === 'Cargo' && (
            <Fragment>
              <Grid container>
                <Grid container item xs={9}>
                  <Grid item xs={2}>
                    <img
                      style={{
                        width: '60px',
                        objectFit: 'contain',
                        margin: '20px 40px 20px 0',
                      }}
                      src={'Mahmoole/residane-mahmoole.svg'}
                      className={classes.icon}
                    />
                  </Grid>
                  <Grid item xs={10} style={{marginTop: '20px'}}>
                    <Grid xs={12}>
                      {' '}
                      <Typography variant="h5" component="h2">
                        {`رسیدن محموله به انبار`}
                      </Typography>
                    </Grid>
                    <Grid xs={12}>
                      <span>
                        {
                          'پس از رسیدن محموله شما به انبار روناد برای شما یک پیامک ارسال خواهد شد'
                        }
                      </span>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  item
                  xs={3}
                  style={{textAlign: 'center', margin: '20px 0 20px 0 '}}
                >
                  <ThemeProvider
                    theme={theme =>
                      createTheme({
                        palette: {
                          primary: {
                            main: '#008000',
                          },
                        },
                      })
                    }
                  >
                    <Switch
                      checked={notificationSwitchs[0]?.parcelAssigned}
                      onChange={() => switchHandler(0, 'parcelAssigned')}
                      color="primary"
                    />
                  </ThemeProvider>
                </Grid>
              </Grid>
              <Divider className={classes.divider} />
              <Grid container>
                <Grid container item xs={9}>
                  <Grid item xs={2}>
                    <img
                      style={{
                        width: '60px',
                        objectFit: 'contain',
                        margin: '20px 40px 20px 0',
                      }}
                      src={'Mahmoole/takhlie-mahmoole.svg'}
                      className={classes.icon}
                    />
                  </Grid>
                  <Grid item xs={10} style={{marginTop: '20px'}}>
                    <Grid xs={12}>
                      {' '}
                      <Typography variant="h5" component="h2">
                        {`تخلیه محموله`}
                      </Typography>
                    </Grid>
                    <Grid xs={12}>
                      <span>
                        {
                          'پس از تخلیه محموله توسط شرکت روناد برای شما پیامک ارسال خواهد شد'
                        }
                      </span>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  item
                  xs={3}
                  style={{textAlign: 'center', margin: '20px 0 20px 0 '}}
                >
                  <ThemeProvider
                    theme={theme =>
                      createTheme({
                        palette: {
                          primary: {
                            main: '#008000',
                          },
                        },
                      })
                    }
                  >
                    <Switch
                      checked={notificationSwitchs[1].parcelUnloaded}
                      onChange={() => switchHandler(1, 'parcelUnloaded')}
                      color="primary"
                    />
                  </ThemeProvider>
                </Grid>
              </Grid>
              <Divider className={classes.divider} />
              <Grid container>
                <Grid container item xs={9}>
                  <Grid item xs={2}>
                    <img
                      style={{
                        width: '60px',
                        objectFit: 'contain',
                        margin: '20px 40px 20px 0',
                      }}
                      src={'Mahmoole/Jaygozari-mahmoole.svg'}
                      className={classes.icon}
                    />
                  </Grid>
                  <Grid item xs={10} style={{marginTop: '20px'}}>
                    <Grid xs={12}>
                      {' '}
                      <Typography variant="h5" component="h2">
                        {`جای‌گذاری محموله`}
                      </Typography>
                    </Grid>
                    <Grid xs={12}>
                      <span>
                        {
                          'پس از پایان جای‌گذاری و پردازش کالاهای محموله برای شما پیامک ارسال خواهد شد'
                        }
                      </span>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  item
                  xs={3}
                  style={{textAlign: 'center', margin: '20px 0 20px 0 '}}
                >
                  <ThemeProvider
                    theme={theme =>
                      createTheme({
                        palette: {
                          primary: {
                            main: '#008000',
                          },
                        },
                      })
                    }
                  >
                    <Switch
                      checked={notificationSwitchs[2].parcelLocated}
                      onChange={() => switchHandler(2, 'parcelLocated')}
                      color="primary"
                    />
                  </ThemeProvider>
                </Grid>
              </Grid>
              <Divider className={classes.divider} />
              <Grid container>
                <Grid container item xs={9}>
                  <Grid item xs={2}>
                    <img
                      style={{
                        width: '60px',
                        objectFit: 'contain',
                        margin: '20px 40px 20px 0',
                      }}
                      src={'Mahmoole/moghayerat-mahmoole.svg'}
                      className={classes.icon}
                    />
                  </Grid>
                  <Grid item xs={10} style={{marginTop: '20px'}}>
                    <Grid xs={12}>
                      {' '}
                      <Typography variant="h5" component="h2">
                        {`مغایرت محموله`}
                      </Typography>
                    </Grid>
                    <Grid xs={12}>
                      <span>
                        {
                          'در صورت مغایرت در محموله برای شما پیامک ارسال خواهد شد'
                        }
                      </span>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  item
                  xs={3}
                  style={{textAlign: 'center', margin: '20px 0 20px 0 '}}
                >
                  <ThemeProvider
                    theme={theme =>
                      createTheme({
                        palette: {
                          primary: {
                            main: '#008000',
                          },
                        },
                      })
                    }
                  >
                    <Switch
                      checked={notificationSwitchs[3].parcelConflicted}
                      onChange={() => switchHandler(3, 'parcelConflicted')}
                      color="primary"
                    />
                  </ThemeProvider>
                </Grid>
              </Grid>
              <Divider className={classes.divider} />
            </Fragment>
          )}
          {notificationsType === 'ORDERS' && (
            <Fragment>
              <Grid container>
                <Grid container item xs={9}>
                  <Grid item xs={2}>
                    <img
                      style={{
                        width: '60px',
                        objectFit: 'contain',
                        margin: '20px 40px 20px 0',
                      }}
                      src={'Sefaresh/Sabt-dar-post.svg'}
                      className={classes.icon}
                    />
                  </Grid>
                  <Grid item xs={10} style={{marginTop: '20px'}}>
                    <Grid xs={12}>
                      {' '}
                      <Typography variant="h5" component="h2">
                        {`ثبت در پست`}
                      </Typography>
                    </Grid>
                    <Grid xs={12}>
                      <span>
                        {
                          'پس از ثبت سفارش در پست،برای مشتری پیامکی شامل کدرهگیری پست ارسال خواهد شد'
                        }
                      </span>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  item
                  xs={3}
                  style={{textAlign: 'center', margin: '20px 0 20px 0 '}}
                >
                  <ThemeProvider
                    theme={theme =>
                      createTheme({
                        palette: {
                          primary: {
                            main: '#008000',
                          },
                        },
                      })
                    }
                  >
                    <Switch
                      checked={notificationSwitchs[4].orderRegisterInPost}
                      onChange={() => switchHandler(4, 'orderRegisterInPost')}
                      color="primary"
                    />
                  </ThemeProvider>
                </Grid>
              </Grid>
              <Divider className={classes.divider} />
            </Fragment>
          )}
          <Grid style={{textAlign: 'left'}}>
            <Button
              // fullWidth
              color="primary"
              size="large"
              variant={'contained'}
              onClick={() => {
                handleSubmitNotifications();
              }}
              disabled={notificationSwitchs[0] ? false : true}
              style={{margin: '20px 0 40px 60px'}}
            >
              ثبت تغییرات
            </Button>
          </Grid>
        </Fragment>
      )}
    </Paper>
  );
};

const mapStateToProps = () =>
  createStructuredSelector<Store, State>({
    partnerConfigs: makeSelectPartnerConfigs(),
    loading: makeSelectLoading(),
    error: makeSelectError(),
  });

function mapDispatchToProps(dispatch: Function) {
  return {
    partnerConfigsDispatch: (payload: Payload) =>
      dispatch(getPartnerConfigsAction(payload)),
    updatePartnerConfigsDispatch: (payload: {
      body: string;
      pagination: object;
    }) => dispatch(updatePartnerConfigs(payload)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Notification);
